<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">Dashboard</h1>
      <div>
        <span
          class="btn-group pull-right m-l-20 p-1 bg-black-transparent-2 rounded"
          :class="{ 'text-gray': inverseMode }"
        >
          <a
            class="btn btn-sm btn-white btn-white-without-border"
            @click.prevent="handleChangeWidgetTheme('light')"
            :class="{ active: !inverseMode }"
            ><i class="fa fa-sun text-primary"></i> Light</a
          >
          <a
            class="btn btn-sm btn-white btn-white-without-border"
            @click.prevent="handleChangeWidgetTheme('inverse')"
            :class="{ active: inverseMode }"
            ><i class="fa fa-moon"></i> Dark</a
          >
        </span>
      </div>
    </div>
    <div class="ts-overflow-x-hidden">
      <!-- begin card -->
      <TotalCard />
      <!-- end card -->
      <!-- begin card -->
      <total-student-status :inverseMode="inverseMode" class="h-full" />
      <!-- end card -->
      <!-- begin card -->
      <total-student-attendance :inverseMode="inverseMode" class="h-full" />
      <!-- end card -->
      <total-student-campus-and-pickup
        :inverseMode="inverseMode"
        class="h-full"
      />
      <!-- begin card -->
      <total-sale-item :inverseMode="inverseMode" class="h-full" />
      <!-- end card -->
      <!-- begin card -->
      <total-unpaid-and-income-by-fee
        :inverseMode="inverseMode"
        class="h-full"
      />
      <!-- end card -->
      <!-- begin card -->
      <total-student-grade :inverseMode="inverseMode" class="h-full" />
      <!-- end card -->
    </div>
  </div>
</template>

<script>
import TotalCard from './dashboard-components/total-card'
import TotalStudentStatus from './dashboard-components/widget/total-student-status'
import TotalSaleItem from './dashboard-components/widget/total-sale-item'
import TotalUnpaidAndIncomeByFee from './dashboard-components/widget/total-unpaid-and-income-by-fee'
import TotalStudentAttendance from './dashboard-components/widget/total-student-attendance'
import TotalStudentGrade from './dashboard-components/widget/total-student-grade'
import TotalStudentCampusAndPickup from './dashboard-components/widget/total-student-campus-and-pickup'
export default {
  name: 'dashboard-v2',
  components: {
    TotalCard,
    TotalStudentStatus,
    TotalSaleItem,
    TotalUnpaidAndIncomeByFee,
    TotalStudentAttendance,
    TotalStudentGrade,
    TotalStudentCampusAndPickup
  },
  data() {
    return {
      inverseMode: false
    }
  },
  methods: {
    handleChangeWidgetTheme: function(theme) {
      if (theme == 'light') {
        this.inverseMode = false
      } else if (theme == 'inverse') {
        this.inverseMode = true
      }
    }
  }
}
</script>
